import { render, staticRenderFns } from "./EditStorageLocation.vue?vue&type=template&id=ce921612&"
import script from "./EditStorageLocation.vue?vue&type=script&lang=js&"
export * from "./EditStorageLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports